import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Col, Row, Icons, Typography, Divider } from '~/components';
import { NextPrevButton } from './style';

function PeriodicidadeNavigation({
  previous,
  previousFunction,
  next,
  nextFunction,
  current,
}) {
  const corTema = useSelector(state => state.configuration.corTema);
  const isMobile = useMediaQuery({ query: '(max-width: 900px)' });

  const currentLabel = (
    <Typography.Text
      strong
      style={{
        display: 'block',
        textAlign: 'center',
        marginTop: '1%',
        fontSize: 20,
        color: corTema,
      }}
    >
      {`${current}`}
    </Typography.Text>
  );

  return (
    <>
      {isMobile ? (
        <>
          <Row>
            <Col xs={12}>
              <NextPrevButton
                onClick={previousFunction}
                aria-label={`Período anterior: ${previous}`}
                style={{ float: 'left', color: corTema }}
              >
                <Icons.LeftOutlined aria-hidden />
                {` ${previous} `}
              </NextPrevButton>
            </Col>

            <Col xs={12}>
              <NextPrevButton
                onClick={nextFunction}
                aria-label={`Próximo período: ${next}`}
                style={{ float: 'right', color: corTema }}
              >
                {`${next} `}
                <Icons.RightOutlined aria-hidden />
              </NextPrevButton>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>{currentLabel}</Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col xs={8}>
              <NextPrevButton
                onClick={previousFunction}
                aria-label={`Período anterior: ${previous}`}
                style={{ float: 'left', color: corTema }}
              >
                <Icons.LeftOutlined aria-hidden />
                {` ${previous} `}
              </NextPrevButton>
            </Col>
            <Col xs={8}>{currentLabel}</Col>
            <Col xs={8}>
              <NextPrevButton
                onClick={nextFunction}
                aria-label={`Próximo período: ${next}`}
                style={{ float: 'right', color: corTema }}
              >
                {`${next} `}
                <Icons.RightOutlined aria-hidden />
              </NextPrevButton>
            </Col>
          </Row>
        </>
      )}

      <Divider style={{ background: '#d0d0d0' }} />
    </>
  );
}

export default PeriodicidadeNavigation;
